// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { Sport } from '../app/states/sport/sport.models';

import { IEnvironment, EnvironmentTier } from './environment.model';

export const environment: IEnvironment = {
    tier: EnvironmentTier.QA,
    production: true,
    apis: {
        [Sport.HOCKEY]: 'https://hockeyappqa.sportlogiq.com',
        [Sport.SOCCER]: 'https://soccerappqa.sportlogiq.com',
        [Sport.FOOTBALL]: 'https://footballappqa.sportlogiq.com'
    },
    apiVersion: 'api/v3',
    userApi: 'https://auth-dev.sportlogiq.com',
    userApiVersion: 'api/v1',
    loginUrl: 'https://oneapp-qa.sportlogiq.com'
};
